import { SET_CERT_SELECTED } from "./actions/selected_actions";

const initialState = {
  data: null, // Case data for 9141
  cert_selected: null, // Case number for 9141
  poc_selection: null, // section C or D
  error: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_CERT_SELECTED:
      return {
        ...state,
        cert_selected: action.meta_case_number,
      };
    default:
      return state;
  }
}
